import {
    SALES_CLOSE_POS_TERMINAL,
    CASH_MANAGEMENT_MAKE_DEPOSITS,
    CASH_MANAGEMENT_MAKE_PAY_INS,
    CASH_MANAGEMENT_MAKE_PAY_OUTS,
    SALES_OPEN_POS_TERMINAL,
    SALES_DISCOUNT,
    SALES_ISSUE_REFUND,
    SALES_VOID_ITEM,
    SALES_VOID_SALES,
    SALES_SERVICE_CHARGE,
    SALES_TOP_UP_GIFT_CARD,
    SALES_TRANSFER_GIFT_CARD,
    SALES_QUICK_OUT_OF_STOCK,
    SALES_SELL_GIFT_CARD,
    SALES_VOID_PAYMENT,
} from 'constant/permissions'
import { ModuleActionContract } from 'models'
import {
    CLEAR_OTHER_MODULE_ACTION,
    FETCH_OTHER_MODULE_ACTION_FAILURE,
    FETCH_OTHER_MODULE_ACTION_START,
    FETCH_OTHER_MODULE_ACTION_SUCCESS,
    SET_NEXT_MODULE,
    TOGGLE_PIN_DIALOG,
} from 'store/actions/otherModuleAction.action'
import { IAction } from 'types/storeTypes'

export enum ENextModule {
    Discount = 1,
    ServiceCharge = 2,
    Void = 3,
    PayIn = 4,
    PayOut = 5,
    Deposit = 6,
    OpenTerminal = 7,
    CloseTerminal = 8,
    InactiveCashActivity = 9,
    IssueRefund = 10,
    TransferGiftCard = 11,
    ToptupGiftCard = 12,
    QuikcOutOfStock = 13,
    SellGiftCard = 14,
    OpenDrawer = 15,
    VoidPayment = 16,
}

export const ENextModulePermission: {
    [key in ENextModule]: number[] | undefined
} = {
    [ENextModule.Discount]: [SALES_DISCOUNT],
    [ENextModule.ServiceCharge]: [SALES_SERVICE_CHARGE],
    [ENextModule.Void]: [SALES_VOID_ITEM, SALES_VOID_SALES],
    [ENextModule.PayIn]: [CASH_MANAGEMENT_MAKE_PAY_INS],
    [ENextModule.PayOut]: [CASH_MANAGEMENT_MAKE_PAY_OUTS],
    [ENextModule.Deposit]: [CASH_MANAGEMENT_MAKE_DEPOSITS],
    [ENextModule.OpenTerminal]: [SALES_OPEN_POS_TERMINAL],
    [ENextModule.InactiveCashActivity]: [
        CASH_MANAGEMENT_MAKE_PAY_INS,
        CASH_MANAGEMENT_MAKE_PAY_OUTS,
        CASH_MANAGEMENT_MAKE_DEPOSITS,
    ],
    [ENextModule.CloseTerminal]: [SALES_CLOSE_POS_TERMINAL],
    [ENextModule.IssueRefund]: [SALES_ISSUE_REFUND],
    [ENextModule.TransferGiftCard]: [SALES_TRANSFER_GIFT_CARD],
    [ENextModule.ToptupGiftCard]: [SALES_TOP_UP_GIFT_CARD],
    [ENextModule.QuikcOutOfStock]: [SALES_QUICK_OUT_OF_STOCK],
    [ENextModule.SellGiftCard]: [SALES_SELL_GIFT_CARD],
    [ENextModule.OpenDrawer]: [
        CASH_MANAGEMENT_MAKE_DEPOSITS,
        CASH_MANAGEMENT_MAKE_PAY_OUTS,
        CASH_MANAGEMENT_MAKE_PAY_INS,
    ],
    [ENextModule.VoidPayment]: [SALES_VOID_PAYMENT],
}

interface IOtherModuleActionState {
    loading: boolean
    otherModuleAction: number[]
    openPinDialog: boolean
    pin?: string
    error?: Error
    nextModule?: ENextModule
}

const initialState: IOtherModuleActionState = {
    loading: false,
    openPinDialog: false,
    otherModuleAction: [],
}

function otherModuleActionReducer(
    state: IOtherModuleActionState = initialState,
    action: IAction,
): IOtherModuleActionState {
    const { payload, type } = action
    switch (type) {
        case FETCH_OTHER_MODULE_ACTION_START:
            return {
                ...state,
                loading: true,
            }
        case FETCH_OTHER_MODULE_ACTION_SUCCESS:
            return {
                ...state,
                pin: payload.pin,
                otherModuleAction: [
                    ...state.otherModuleAction,
                    ...payload.data.map(
                        (i: ModuleActionContract) => i.moduleActionID,
                    ),
                ],
                loading: false,
                openPinDialog: false,
            }
        case FETCH_OTHER_MODULE_ACTION_FAILURE:
            return {
                ...state,
                error: payload,
                loading: false,
                pin: undefined,
            }
        case CLEAR_OTHER_MODULE_ACTION:
            return {
                ...state,
                pin: undefined,
                otherModuleAction: [],
            }
        case TOGGLE_PIN_DIALOG:
            return {
                ...state,
                openPinDialog: payload,
            }
        case SET_NEXT_MODULE: {
            return {
                ...state,
                nextModule: payload.module,
            }
        }

        default:
            return state
    }
}

export default otherModuleActionReducer
